// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"loadingBox-3FvWM897","loadingbanner":"loadingbanner-5pbqdhBV","flare":"flare-2nuMNYht"};